import { useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";

// Route guard for internal/admin-only pages (Regulatory Intelligence suite).
// Redirects anonymous visitors to login instead of leaving them on a page
// whose data reads will 401 under RLS with no visible error state.
export default function AdminRouteGuard({ children }) {
  const { user, isLoadingAuth, navigateToLogin } = useAuth();

  useEffect(() => {
    if (!isLoadingAuth && !user) {
      navigateToLogin();
    }
  }, [isLoadingAuth, user, navigateToLogin]);

  if (isLoadingAuth || !user) {
    return (
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-slate-200 border-t-slate-800 rounded-full animate-spin"></div>
      </div>
    );
  }

  return children;
}